
export default {
	props: {
		games: {
			type: Array,
			required: true
		}
	},
	methods: {
		handleClick(gameItem) {
			this.$emit('item-click', gameItem)
		}
	}
}
